module.exports = __webpack_public_path__ + "img/6.388d689e.jpg";